import {
  AGREEMENT_TYPE_LABELS,
  AGREEMENT_TYPES,
} from '../../constants/agreementConstants';
import {
  ACH_TERMS,
  IRA_TERMS,
  TWO_FA_CHOOSE_PHONE_METHOD,
  TWO_FA_FORGOT_PASSWORD_IDENTITY_HAVING_TROUBLE_PAGE,
  TWO_FA_FORGOT_PASSWORD_IDENTITY_PAGE,
  TWO_FA_FORGOT_PASSWORD_IDENTITY_PHONE_PAGE,
  TWO_FA_FORGOT_PASSWORD_PAGE,
  TWO_FA_HAVING_TROUBLE_PAGE,
  TWO_FA_QR_CODE_PAGE,
  TWO_FA_SUCCESSFUL_SETUP,
  TWO_FA_VERIFY_CODE,
  TWO_FA_VERIFY_IDENTITY,
  USER_TERMS,
  VERIFY_CHOOSE_METHOD_PAGE,
} from '../../constants/pages';

export const termsArrayHelper = (termsArray) => {
  if (!termsArray || !termsArray?.length) {
    return {
      label: '',
      value: '',
    };
  }

  return termsArray.map((term) => ({
    label: AGREEMENT_TYPE_LABELS[term],
    value: AGREEMENT_TYPES[term],
  }));
};

export const hideAgreementModalPages = [
  USER_TERMS,
  ACH_TERMS,
  IRA_TERMS,
  VERIFY_CHOOSE_METHOD_PAGE,
  TWO_FA_QR_CODE_PAGE,
  TWO_FA_CHOOSE_PHONE_METHOD,
  TWO_FA_VERIFY_CODE,
  TWO_FA_SUCCESSFUL_SETUP,
  TWO_FA_VERIFY_IDENTITY,
  TWO_FA_HAVING_TROUBLE_PAGE,
  TWO_FA_FORGOT_PASSWORD_PAGE,
  TWO_FA_FORGOT_PASSWORD_IDENTITY_PAGE,
  TWO_FA_FORGOT_PASSWORD_IDENTITY_PHONE_PAGE,
  TWO_FA_FORGOT_PASSWORD_IDENTITY_HAVING_TROUBLE_PAGE,
];
